module.exports = __webpack_public_path__ + "img/payment_link_active.48c55ac6.svg";